import React from "react";
import { Skeleton, SxProps, Theme } from "@mui/material";

interface SkeletonLoaderProps {
  variant?: "text" | "rectangular" | "circular";
  width?: number | string;
  height?: number | string;
  sx?: SxProps<Theme>;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  variant = "text",
  width,
  height,
  sx,
}) => {
  return (
    <Skeleton
      variant={variant}
      width={width}
      height={height}
      animation="wave"
      sx={sx}
    />
  );
};
